import React from 'react'
import NavbarProjects from './NavbarProjects'
import BannerBackground from "../Assets/home-banner-background.png";
import Cards from "./Cards"

function Projects() {
  return (
    <div className="home-container">
      <NavbarProjects />
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" />
        </div>
        </div>
        <div className="home-text-section">
          <h1 className="primary-heading">
            Especialistas en Sistemas Hidraulicos
          </h1>
        </div>
        <Cards/>
          
    </div>
    
  )
}

export default Projects